import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages are pre-rendered to static HTML at build time (scripts/prerender.js);
// hydrate that markup instead of re-rendering from scratch. If the HTML was
// rendered for a different URL (CloudFront serves /index.html for unknown
// paths), render fresh instead.
if (rootElement.dataset.prerendered === window.location.pathname) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  rootElement.replaceChildren();
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
